import React from "react";

import { useTranslation } from "react-i18next";
import { useResponsiveBreakpoints } from "~/hooks/useResponsiveBreakpoints";

import { Button } from "@local-logic/design-system";

import { TrafficSignIcon } from "@phosphor-icons/react";

import { useRootElement } from "../context";

import * as styles from "./styles";

export function Trigger() {
  const { t } = useTranslation("localContent");
  const breakpoints = useResponsiveBreakpoints();
  const { isOpen, onToggleIsOpen } = useRootElement();

  return (
    <Button
      className={styles.container}
      prefixIcon={<TrafficSignIcon className={styles.icon} />}
      data-testid="commute-calculator-trigger"
      data-is-active={isOpen}
      onClick={onToggleIsOpen}
    >
      {t("commute.cta", { context: breakpoints.xs ? "long" : "short" })}
    </Button>
  );
}
